import React from "react";
import "../App.css";

export default function Timeline({ items }) {
    return (
        <div className="timeline-vertical">
            <div className="timeline-line" />
            <div className="timeline-items">
                {items.map((it, idx) => (
                    <div className="timeline-row" key={it.time + it.name}>
                        <div className="timeline-time">{it.time}</div>
                        <div className="timeline-dot" />
                        <div className="timeline-desc">{it.name}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
